import {Outlet} from 'external/react'
import {styled, clsx, Box} from 'external/material'
import useSession from 'hooks/session'

import Filters from './Filters'
import Toolbar from './Toolbar'

const StyledCalendar = styled(Box)(calendarStyles)

export default function CalendarContainer() {
  const {scheduleView, navigation} = useSession()
  return (
    <StyledCalendar className="calendarWrapper">
      <Box className={clsx('calendarContainer', 'calendar', 'view', {[scheduleView]: navigation.scheduleView.active})}>
        <Toolbar />
        <Box id="calendarContentWrapper" className="calendarContentWrapper">
          <Box id="calendarContentContainer" className={clsx('calendarContentContainer', 'calendar')}>
            <Filters />
            <Outlet />
          </Box>
        </Box>
      </Box>
    </StyledCalendar>
  )
}

function calendarStyles() {
  return {
    "&.calendarWrapper": {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      padding:0,
      padding: '5px 20px',
      overflowY: 'hidden'
    },
    "& .calendarContainer": {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      flexGrow: 1,
      overflowY: 'hidden',
    },
    "& .calendarContentWrapper": {
      display: 'flex',
      flexDirection: 'column',
      padding: '19px 20px 20px 20px',
      flexGrow: 1,
      overflowY: 'hidden',
    },
    "& .calendarContentContainer": {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'auto',
      border: 'solid 1px #e1eaee',
    },
  }
}
